<div class="account-section">
  <div class="my-section-box">
    @if (tableData) {
      <form [formGroup]="endurasureSummaryForm">
        <div class="my-section-box__headline">
        {{ 'common.value_calculator_enduraSure_summary' | cxTranslate }}</div>
        <div class="my-section-box endurasureSummary" id="endurasureSummary">
          <div class="my-section-box-inner fleet-info-block">
            <div class="enduraSuretable-css">
              <table class="EnduraSureTable">
                <tbody>
                  <tr>
                    <th colspan="2">{{ 'common.value_calculator_standardChamberLifetime' |
                    cxTranslate }}</th>
                    <th rowspan="2">{{ 'common.value_calculator_description' | cxTranslate }} </th>
                    <th colspan="2">{{ 'common.value_calculator_sealedChamberLifetime' | cxTranslate
                    }}</th>
                  </tr>
                  <tr>
                    <th>{{ 'common.value_calculator_unit_cost' | cxTranslate }}</th>
                    <th>{{ 'common.value_calculator_totalFleet_cost' | cxTranslate }}</th>
                    <th>{{ 'common.value_calculator_unit_cost' | cxTranslate }}</th>
                    <th>{{ 'common.value_calculator_totalFleet_cost' | cxTranslate }}</th>
                  </tr>
                  <tr>
                    <td class="standard-Unit-Tractor">{{tableData[0]?.standardUnit.toFixed(2)}}</td>
                    <td class="standard-Fleet-Tractor">
                      {{tableData[0]?.standardFleet.toLocaleString('en-US', { style: 'decimal',
                    maximumFractionDigits: 0 })}}</td>
                    <td>{{ 'common.value_calculator_initialpurchase_tractor_cost' | cxTranslate }}
                    </td>
                    <td class="sealed-Unit-Tractor">{{tableData[0]?.sealedUnit.toFixed(2)}}</td>
                    <td class="sealed-Fleet-Tractor">
                      {{tableData[0]?.sealedFleet.toLocaleString('en-US', { style: 'decimal',
                    maximumFractionDigits: 0 })}}</td>
                  </tr>
                  <tr>
                    <td class="standard-Unit-Trailer">{{tableData[1]?.standardUnit.toFixed(2)}}</td>
                    <td class="standard-Total-Trailer">
                      {{tableData[1]?.standardFleet.toLocaleString('en-US', { style: 'decimal',
                    maximumFractionDigits: 0 })}}</td>
                    <td>{{ 'common.value_calculator_initialpurchase_trailer_cost' | cxTranslate }}
                    </td>
                    <td class="sealed-Unit-Trailer">{{tableData[1]?.sealedUnit.toFixed(2)}}</td>
                    <td class="sealed-Fleet-Trailer">
                      {{tableData[1]?.sealedFleet.toLocaleString('en-US', { style: 'decimal',
                    maximumFractionDigits: 0 })}}</td>
                  </tr>
                  <tr>
                    <td class="standard-Unit-life-Tractor">{{tableData[2]?.standardUnit.toFixed(2)}}
                    </td>
                    <td class="standard-Total-life-Tractor">
                      {{tableData[2]?.standardFleet.toLocaleString('en-US', { style: 'decimal',
                    maximumFractionDigits: 0 })}}</td>
                    <td>{{ 'common.value_calculator_replacementTractor_cost' | cxTranslate }}</td>
                    <td class="sealed-Unit-life-Tractor">{{tableData[2]?.sealedUnit.toFixed(2)}}
                    </td>
                    <td class="sealed-Fleet-life-Tractor">
                      {{tableData[2]?.sealedFleet.toLocaleString('en-US', { style: 'decimal',
                    maximumFractionDigits: 0 })}}</td>
                  </tr>
                  <tr>
                    <td class="standard-Unit-life-Trailer">{{tableData[3]?.standardUnit.toFixed(2)}}
                    </td>
                    <td class="standard-Fleet-life-Trailer">
                      {{tableData[3]?.standardFleet.toLocaleString('en-US', { style: 'decimal',
                    maximumFractionDigits: 0 })}}</td>
                    <td>{{ 'common.value_calculator_replacementTrailer_cost' | cxTranslate }}</td>
                    <td class="sealed-Unit-life-Trailer">{{tableData[3]?.sealedUnit.toFixed(2)}}
                    </td>
                    <td class="sealed-Fleet-life-Trailer">
                      {{tableData[3]?.sealedFleet.toLocaleString('en-US', { style: 'decimal',
                    maximumFractionDigits: 0 })}}</td>
                  </tr>
                  <tr>
                    <td class="standard-Unit-csaTractor">{{tableData[4]?.standardUnit.toFixed(2)}}
                    </td>
                    <td class="standard-Fleet-csaTractor">
                      {{tableData[4]?.standardFleet.toLocaleString('en-US', { style: 'decimal',
                    maximumFractionDigits: 0 })}}</td>
                    <td>{{ 'common.value_calculator_csaTractor_cost' | cxTranslate }}</td>
                    <td class="sealed-Unit-csaTractor">{{tableData[4]?.sealedUnit.toFixed(2)}}</td>
                    <td class="sealed-Fleet-csaTractor">
                      {{tableData[4]?.sealedFleet.toLocaleString('en-US', { style: 'decimal',
                    maximumFractionDigits: 0 })}}</td>
                  </tr>
                  <tr>
                    <td class="standard-Unit-csaTrailer">{{tableData[5]?.standardUnit.toFixed(2)}}
                    </td>
                    <td class="standard-Fleet-csaTrailer">
                      {{tableData[5]?.standardFleet.toLocaleString('en-US', { style: 'decimal',
                    maximumFractionDigits: 0 })}}</td>
                    <td>{{ 'common.value_calculator_csaTrailer_cost' | cxTranslate }}</td>
                    <td class="sealed-Unit-csaTrailer">{{tableData[5]?.sealedUnit.toFixed(2)}}</td>
                    <td class="sealed-Fleet-csaTrailer">
                      {{tableData[5]?.sealedFleet.toLocaleString('en-US', { style: 'decimal',
                    maximumFractionDigits: 0 })}}</td>
                  </tr>
                  <tr>
                    <td class="standard-Unit-Total ui-weight">
                    {{tableData[6]?.standardUnit.toFixed(2)}}</td>
                    <td class="standard-Fleet-Total ui-weight">
                      {{tableData[6]?.standardFleet.toLocaleString('en-US', { style: 'decimal',
                    maximumFractionDigits: 0 })}}</td>
                    <td class="ui-weight">{{ 'common.value_calculator_total_text' | cxTranslate }}
                    </td>
                    <td class="sealed-Unit-Total ui-weight">{{tableData[6]?.sealedUnit.toFixed(2)}}
                    </td>
                    <td class="sealed-Fleet-Total ui-weight">
                      {{tableData[6]?.sealedFleet.toLocaleString('en-US', { style: 'decimal',
                    maximumFractionDigits: 0 })}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <br>
              <div class="enduraSuretable2-css">
                <table class="ROITable">
                  <tbody>
                    <tr>
                      <th colspan="2">{{ 'common.value_calculator_return_investment' | cxTranslate }}
                      </th>
                    </tr>
                    <tr class="ui-weight">
                      <td class="roi_left">{{ 'common.value_calculator_TCO_perUnit_standard' |
                      cxTranslate }}</td>
                      <td class="TCO-Standard">{{tableData[7]?.TcoStandard.toFixed(2)}}</td>
                    </tr>
                    <tr class="ui-weight">
                      <td class="roi_left">{{ 'common.value_calculator_TCO_perUnit_Sealed' |
                      cxTranslate }}</td>
                      <td class="TCO-Sealed">{{tableData[7]?.TcoSealed.toFixed(2)}}</td>
                    </tr>
                    <tr class="ui-weight">
                      <td class="roi_left">{{ 'common.value_calculator_fleet_saving' | cxTranslate }}
                      </td>
                      <td class="Net-Savings">{{tableData[7]?.NetSavings.toLocaleString('en-US', {
                      style: 'decimal', maximumFractionDigits: 0 })}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <br>
                <div class="enduraSure-graph">
                  <img src="/images/Kb-enduraSure-graph.jpg" alt="kb-enduraSure-graph">
                </div>
                <br>
                  <div class="paragraph-Summary">
                    <p>{{ 'common.endurasure_summary_paragraph1' | cxTranslate }}</p>
                    <p>{{ 'common.endurasure_summary_paragraph2' | cxTranslate }}</p>
                    <p>{{ 'common.endurasure_summary_paragraph3' | cxTranslate }}</p>
                    <p>{{ 'common.endurasure_summary_paragraph4' | cxTranslate }}</p>
                    <p>{{ 'common.endurasure_summary_paragraph5' | cxTranslate }}</p>
                    <p>{{ 'common.endurasure_summary_paragraph6' | cxTranslate }}</p>
                  </div>
                  <div class="airdisk-button-block endasure-button-block">
                    <button type="button" class="btn btn-primary endaSureBack  yellow-btn"
                      (click)="endaSureBack()"><img src="/icons/link-right-white.svg" class="right-arrow"
                      alt="">
                    {{ 'common.value_calculator_back_button' | cxTranslate }}</button>
                    <button type="button" class="btn btn-primary endaSureRest  yellow-btn"
                      (click)="resetForms()">{{ 'common.value_calculator_reset_text' | cxTranslate }}
                      <img src="/icons/link-right-white.svg" class="right-arrow" alt=""></button>
                      <mat-dialog-actions>
                        <button type="button" class="btn btn-primary EmailResults yellow-btn"
                          (click)="emailPopup()">{{ 'common.value_calculator_email_results' | cxTranslate }}
                          <img src="/icons/link-right-white.svg" class="right-arrow" alt=""></button>
                        </mat-dialog-actions>
                      </div>
                    </div>
                  </div>
                </form>
              }
            </div>
          </div>